import React, { useState, useEffect } from 'react';
import './ScoreGauge.css';

export default function ScoreGauge({ score = 0, color = null }) {
    const [displayScore, setDisplayScore] = useState(0);
    const clampedScore = Math.max(0, Math.min(100, score));

    // Count-up animation effect
    useEffect(() => {
        let start = 0;
        const duration = 1500; // 1.5s
        const stepTime = clampedScore > 0 ? Math.abs(Math.floor(duration / clampedScore)) : 10;

        const timer = setInterval(() => {
            start += 1;
            setDisplayScore(start);
            if (start >= clampedScore) clearInterval(timer);
        }, stepTime);

        return () => clearInterval(timer);
    }, [clampedScore]);

    const getScoreColor = (score) => {
        if (score >= 71) return '#4E8D5B'; // Sage green
        if (score >= 31) return '#C99A3B'; // Warm amber
        return '#B5533A'; // Warm clay red
    };

    const scoreColor = color || getScoreColor(clampedScore);

    // SVG parameters for a 3/4 circle
    const size = 220;
    const strokeWidth = 14;
    const radius = size / 2 - strokeWidth;
    const center = size / 2;
    const circumference = 2 * Math.PI * radius;

    // We want the arc to cover 270 degrees (3/4 of a circle)
    const arcLength = (270 / 360) * circumference;
    const offset = arcLength - (clampedScore / 100) * arcLength;

    return (
        <div className="score-gauge-modern">
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                {/* Background Track */}
                <circle
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    strokeWidth={strokeWidth}
                    strokeDasharray={`${arcLength} ${circumference}`}
                    strokeLinecap="round"
                    className="gauge-track"
                    style={{ transform: 'rotate(135deg)', transformOrigin: 'center' }}
                />

                {/* Active Glowing Arc */}
                <circle
                    cx={center}
                    cy={center}
                    r={radius}
                    fill="none"
                    stroke={scoreColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={`${arcLength} ${circumference}`}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    className="gauge-path"
                    style={{
                        transform: 'rotate(135deg)',
                        transformOrigin: 'center',
                        filter: `drop-shadow(0 0 8px ${scoreColor}44)`
                    }}
                />
            </svg>

            <div className="score-content">
                <span className="score-number-modern" style={{ color: scoreColor }}>
                    {displayScore}
                </span>
                <span className="score-percent">%</span>
            </div>
        </div>
    );
}
